import { SVGProps } from 'react'

const NewLinkedInIconSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.78357 4.16645C5.78326 4.84504 5.37157 5.45569 4.74262 5.71045C4.11367 5.96521 3.39306 5.81321 2.92059 5.32613C2.44811 4.83904 2.31813 4.11413 2.59192 3.49323C2.86572 2.87233 3.48862 2.47942 4.1669 2.49978C5.0678 2.52682 5.78398 3.26515 5.78357 4.16645ZM5.83357 7.06645H2.50024V17.4998H5.83357V7.06645ZM11.1003 7.06645H7.78357V17.4998H11.0669V12.0248C11.0669 8.97475 15.0419 8.69142 15.0419 12.0248V17.4998H18.3336V10.8914C18.3336 5.74978 12.4503 5.94145 11.0669 8.46642L11.1003 7.06645Z"
      fill="white"
    />
  </svg>
)

export default NewLinkedInIconSvg
